import script from "./ButtonCopyToClipboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonCopyToClipboard.vue?vue&type=script&setup=true&lang=js"

import "./ButtonCopyToClipboard.vue?vue&type=style&index=0&id=5c649fe6&lang=css"

const __exports__ = script;

export default __exports__